// extracted by mini-css-extract-plugin
module.exports = {"star":"FavoriteToggle_star__LC_ZN","on":"FavoriteToggle_on__SN8Py","busy":"FavoriteToggle_busy__XDI4j","mark":"FavoriteToggle_mark__yWmpK"};